module.exports = __webpack_public_path__ + "img/chengxinbaoPlus.ed8010b4.png";